

Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.AdvancedConfigurations = class {

    locale = Monet.Session.User.preferedLocale;
    className = 'AdvancedConfigurations';

    fields = {
        timezone: null,
        numberFormat: null,
        dateFormat: null,
        dateTimeFormat: null,
        calculatePlanning: null,
        resequence: null,
        combineOrders: null
    };

    window = null;

    labelContent = (resource, field) => {
        const div = document.createElement("div"),
            label = document.createElement("label");

        div.className = 'config-el';
        label.innerHTML = Monet.I18n.getResourcesByKey(resource);

        div.appendChild(label);
        div.appendChild(field);
        return div;
    };

    creatingCheckField = (label, defaultValue) => {
        const field = new Monet.UI.Fields.Checkbox();
        const inputName = Monet.I18n.getResourcesByKey(label);

        field.setTextLabel(Monet.I18n.getResourcesByKey(inputName));
        field.render();
        field.setChecked(defaultValue);
        field.rootEl.className = 'config-el checkbox';
        
        if(inputName) {
            field.setInputName(inputName.replace(/\s/g, '_'));
        }

        return field;
    };

    calculatePlanningCheck = () => {
        this.fields.calculatePlanning = this.creatingCheckField("textfile.calculatePlanning", true);
        return this.fields.calculatePlanning.rootEl;
    };

    resequenceCheck = () => {
        this.fields.resequence = this.creatingCheckField("textfile.resequence", false);
        return this.fields.resequence.rootEl;
    };

    combineOrdersCheck = () => {
        this.fields.combineOrders = this.creatingCheckField("textfile.combineOrders", false);
        return this.fields.combineOrders.rootEl;
    };

    numberFormat = () => {
        const field = new Monet.UI.Fields.PickListEditable();

        field.setFieldDomains(Greenmile.DataImport.Utils.getFormatterOptionsByType('DOUBLE').fieldDomains);
        field.render();
        field.setInputValue("");

        this.fields.numberFormat = field;

        return this.labelContent("textfile.numberFormat", field.rootEl);
    };

    dateFormat = () => {
        const field = new Monet.UI.Fields.PickListEditable();

        field.setFieldDomains(Greenmile.DataImport.Utils.getFormatterOptionsByType('DATE').fieldDomains);

        field.render();
        field.setInputValue("");

        this.fields.dateFormat = field;
        return this.labelContent("textfile.dateFormat", field.rootEl);
    };

    dateTimeFormat = () => {
        const field = new Monet.UI.Fields.PickListEditable();
        field.setFieldDomains(Greenmile.DataImport.Utils.getFormatterOptionsByType('DATETIME').fieldDomains);

        field.render();
        field.setInputValue("");

        this.fields.dateTimeFormat = field;
        return this.labelContent("textfile.dateTimeFormat", field.rootEl);
    };

    timezone = () => {
        const lookup = new Monet.UI.Fields.PowerLookup();

        lookup.setId('lookupTimeZone');
        lookup.setNameSpace('DataImportLookupTimeZone');
        lookup.setDisplayKey('description');
        lookup.setLookUpEntity('TimeZone');

        this.fields.timezone = lookup;
        return this.labelContent("textfile.timezone", lookup.render());
    };

    fileEncoding = () => {

        const encoding = new Monet.UI.Fields.PickList(),
            ajax = new Monet.Ajax();

        encoding.setId('encoding');
        ajax.url = "TextFileLayout/supportedEncodings";
        ajax.method = "GET";
        ajax.success = function (data) {
            data = data.map(function(item) {
                return {
                    description: item,
                    value: item
                };
            });
            data.unshift({description: "", value: ""});
            encoding.setData(data);
        };
        ajax.send();

        this.fields.encoding = encoding;
        return this.labelContent("textfile.encoding", encoding.render());


    };

    buttons = () => {
        const saveFn = () => {
            App.Forms.DataImport.CSVConfigurations.value = App.Forms.DataImport.CSVConfigurations.value || {};
            App.Forms.DataImport.CSVConfigurations.value.configuration = this.getValue();
            this.showWindow();
        };

        const saveBtn =  new Monet.UI.Fields.Render({
            customJavaScript: saveFn,
            label: 'default.button.save',
            type: 'BUTTON'
        }).render();

        saveBtn.setId('save-btn');
        return saveBtn.rootEl;

    };

    createBaseStructure = () => {

        this.rootEl = document.createElement('div');
        var btn = document.createElement('div');
        var window = document.createElement('div');
        var closeWindow = document.createElement('div');

            this.rootEl.className = this.className;
            btn.className = 'button gmfont icon-configs fa-2x';
            window.className = 'window';
            closeWindow.className = 'remove';

        window.appendChild(closeWindow);
        window.appendChild(this.timezone());
        window.appendChild(this.numberFormat());
        window.appendChild(this.dateFormat());
        window.appendChild(this.dateTimeFormat());
        window.appendChild(this.fileEncoding());

        if(App.Forms.DataImport.EntityList.selectedValue === "com.greenmile.web.domain.Route") {
            window.appendChild(this.calculatePlanningCheck());
            window.appendChild(this.resequenceCheck());
            window.appendChild(this.combineOrdersCheck());
        }
        window.appendChild(this.buttons());

        btn.setAttribute('title', Monet.I18n.getResourcesByKey('Greenmile.DataImport.AdvancedConfigurations'));
        btn.addEventListener('click', this.showWindow.bind(this));
        closeWindow.addEventListener('click', this.showWindow.bind(this));
        this.rootEl.appendChild(btn);
        this.rootEl.appendChild(window);

        this.window = window;
    };

    showWindow = () => {
        if (this.window.className.indexOf("show") === -1) {
            this.window.className += " show";
        } else {
            this.window.className = this.window.className.replace("show", "").trim();
        }
        if(App.Forms.DataImport.CSVConfigurations.value) {
            this.setValue(App.Forms.DataImport.CSVConfigurations.value.configuration);
        }
    };

    getValue = () => {
        const timezone = this.fields.timezone.getValue();
        const calculatePlanning = (this.fields.calculatePlanning ? this.fields.calculatePlanning.getValue(): undefined);
        const resequence = (this.fields.resequence ? this.fields.resequence.getValue(): undefined);
        const combineOrders = (this.fields.combineOrders ? this.fields.combineOrders.getValue(): undefined);

        return {
            timezoneId: (timezone ? timezone.id : null),
            dateFormat: this.fields.dateFormat.getValue(),
            dateTimeFormat: this.fields.dateTimeFormat.getValue(),
            numberFormat: this.fields.numberFormat.getValue(),
            encoding: this.fields.encoding.getValue(),
            calculatePlanning: calculatePlanning,
            resequence: resequence,
            combineOrders: combineOrders
        };
    };

    setValue = (data) => {      
        const timezoneValue = (data.timezoneId ? { id: data.timezoneId } : null);

        if(this.fields.calculatePlanning) {
            this.fields.calculatePlanning.setChecked(data.calculatePlanning)
        }
        
        this.fields.timezone.setValue(timezoneValue);
        this.fields.dateFormat.setValue(data.dateFormat);
        this.fields.dateTimeFormat.setValue(data.dateTimeFormat);
        this.fields.numberFormat.setValue(data.numberFormat);
        this.fields.encoding.setValue(data.encoding);

        if(this.fields.resequence) {
            this.fields.resequence.setValue(data.resequence)
        }

        if(this.fields.combineOrders) {
            this.fields.combineOrders.setValue(data.combineOrders)
        }

    };

    render = () => {

        this.createBaseStructure();

        return this.rootEl;
    };

}
